import { render, staticRenderFns } from "./hero-header.vue?vue&type=template&id=8732ab06&scoped=true&lang=pug&"
import script from "./hero-header.vue?vue&type=script&lang=js&"
export * from "./hero-header.vue?vue&type=script&lang=js&"
import style0 from "./hero-header.vue?vue&type=style&index=0&id=8732ab06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8732ab06",
  null
  
)

export default component.exports